import { actionTypes } from '../actions/data';

// DEFAULT STATE
export const initData = {
  strategies: [],
};

// WRITES
const data = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.STRATEGIES:
      return Object.assign({}, state, {
        strategies: action.value,
      });
    default:
      return state;
  }
};

// READS
export const getStrategies = (state) => state.data.strategies;

export const getStrategy = (state) => {
  const strats = state.data.strategies.sort((a, b) => (a.updateDate < b.updateDate) ? 1 : -1);
  console.log(strats)
  if(strats.length > 0) {
    const strat = strats[0];
    return strat;
  } else {
    return null;
  }
}

export const getOptimizedStrategy = (state) => {
  const strats = state.data.strategies.sort((a, b) => (a.updateDate < b.updateDate) ? 1 : -1);
  if(strats.length > 0) {
    const strat = strats[0];
    return strat.latestOptimizedAnalysis;
  } else {
    return null;
  }
}

export default data;
